module.exports = __webpack_public_path__ + "img/Zwemvest_verplicht.87f6f352.jpg";